<mat-sidenav-container [hasBackdrop]="true" class="add-option-purchase">
  <mat-sidenav-content>
    <app-add-reference-card
      class="btn-existing"
      desc="You have not added any OTP yet."
      btnLabel="Add option to purchase"
      type="flat-button"
      icon="add"
      (btnClickHandler)="!isReadOnly && addNewOption()"
      (recAclAslHandler)="!isReadOnly && navigateToItemVendor()"
      [hasExtraButton]="true"
      btnLabelTwo="Select from existing item list"
      iconTwo="keyboard_return"
      *ngIf="dataSource.data.length < 1"
      [disabled]="isReadOnly"
    >
    </app-add-reference-card>

    <ng-container *ngIf="dataSource.data.length > 0">
      <app-button
        icon="add"
        name="Add option to purchase"
        tabindex="0"
        (keypress)="!isReadOnly && addNewOption()"
        (click)="!isReadOnly && addNewOption()"
        type="flat-button"
        [disabled]="isReadOnly"
      ></app-button>
      <app-button
        class="btn-select"
        icon="keyboard_return"
        name="Select from existing item list"
        tabindex="0"
        (keypress)="!isReadOnly && navigateToItemVendor()"
        (click)="!isReadOnly && navigateToItemVendor()"
        type="flat-button"
        [disabled]="isReadOnly"
      ></app-button>
      <table
        class="mat-elevation-z8 tb-container"
        mat-table
        multiTemplateDataRows
        matSort
        [dataSource]="dataSource"
        *ngIf="dataSource.data.length > 0"
      >
      <ng-container *ngFor="let column of columnsToDisplay; let i = index">
        <!-- first column -->
        <ng-container [matColumnDef]="column" *ngIf="i == 0">
          <th mat-header-cell *matHeaderCellDef>
            Item No
          </th>
          <td mat-cell *matCellDef="let row; let rowIndex = dataIndex">
            <ng-container
              class="item-row-hover"
              *ngIf="row.hovered && !row.isDeleted && !isReadOnly && !row.Strikethrough"
            >
              <a (click)="navigateToAddItem(row, rowIndex)">
                <div class="row-button">
                  <mat-icon title="Edit">edit</mat-icon>
                  <!-- <span class="tooltip-text">Edit</span> -->
                </div>
              </a>
              <a (click)="openDialog(row, rowIndex)" *ngIf="row[column] ==='-'">
                <div class="row-button">
                  <mat-icon title="Discard">delete</mat-icon>
                  <!-- <span class="tooltip-text">Discard</span> -->
                </div>
              </a>
              </ng-container>
              <ng-container class="item-row-hover" *ngIf="row.hovered && !row.isDeleted && isReadOnly && !row.Strikethrough">
                <a (click)="navigateToAddItem(row, null)">
                  <div class="row-button">
                    <mat-icon title="visibility">visibility</mat-icon>
                  </div>
              </a>
              </ng-container>
              <div class="item-row-no" *ngIf="!row.hovered" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough }">
                {{ row[column] }}
              </div>
          </td>
          </ng-container>

          <ng-container [matColumnDef]="column" *ngIf="i >= 1">
            <th mat-header-cell *matHeaderCellDef>
              {{ column }}
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough }">
              {{ (column === 'EstimatedUnitPrice') ? (row[column] | number: '1.2') : row[column] }}
            </td>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay" (mouseenter)="row.hovered = true"
          (mouseleave)="row.hovered = false"></tr>
      </table>
    </ng-container>
    <mat-paginator
      [ngClass]="{ 'd-none': dataSource.data.length < 1 }"
      [length]="dataSource.data.length"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
    ></mat-paginator>
  </mat-sidenav-content>
  <mat-sidenav #optionPurchaseAdd mode="over" position="end">
    <ng-container *ngIf="optionPurchaseType === 1">
      <app-add-new-option-purchase
        [optionPurchaseNav]="optionPurchaseAdd"
        title="Add new option to purchase"
        [dataForm]="dataSource.data"
      ></app-add-new-option-purchase>
    </ng-container>
    <ng-container *ngIf="optionPurchaseType === 2">
      <app-add-new-option-purchase
        [optionPurchaseNav]="optionPurchaseAdd"
        [optionPurchaseEdit]="optionPurchaseEdit"
        title="Edit option to purchase"
        [dataForm]="dataSource.data"
      ></app-add-new-option-purchase>
    </ng-container>
  </mat-sidenav>
</mat-sidenav-container>
